const swearWords = [
  "anal",
  "anus",
  "arse",
  "asshole",
  "ballsack",
  "balls",
  "bastard",
  "bitch",
  "biatch",
  "bloody",
  "blowjob",
  "blow job",
  "bollock",
  "bollok",
  "boner",
  "boob",
  "bugger",
  "bum",
  "butt",
  "buttplug",
  "clitoris",
  "cock",
  "coon",
  "crap",
  "cunt",
  "cum",
  "damn",
  "dick",
  "dickhead",
  "dildo",
  "dyke",
  "fag",
  "faggot",
  "fuckwit",
  "feck",
  "fellate",
  "fellatio",
  "felching",
  "fucking",
  "fuck",
  "f u c k",
  "fudgepacker",
  "fudge packer",
  "flange",
  "minge",
  "fanny",
  "Goddamn",
  "God damn",
  "homo",
  "jerk",
  "jizz",
  "knobhead",
  "knobend",
  "knob end",
  "labia",
  "lmao",
  "lmfao",
  "muff",
  "nigger",
  "nigga",
  "omg",
  "penis",
  "piss",
  "poop",
  "prick",
  "pube",
  "pussy",
  "queer",
  "scrotum",
  "sex",
  "shit",
  "s hit",
  "sh1t",
  "slut",
  "slag",
  "skank",
  "smegma",
  "spunk",
  "tit",
  "tosser",
  "tossa",
  "tranny",
  "turd",
  "twat",
  "vagina",
  "wanker",
  "wank",
  "whore",
  "vag",
];

const stripNaughtyWords = (el) => {
  const filterSwearWords = () => {
    swearWords.forEach((word) => {
      el.value = el.value.replaceAll(word, "");
    });
  };
  el.addEventListener("change", filterSwearWords);
};

export { stripNaughtyWords };
